import React from "react";

// ----------------------------  DraftStatus  ----------------------------

interface DraftStatusProps {
  dirty: boolean;
  lastSavedAt: Date | null;
  submitted: boolean;
}

const DraftStatus: React.FC<DraftStatusProps> = ({ dirty, lastSavedAt, submitted }) => {
  const base: React.CSSProperties = { fontSize: "1rem", fontWeight: 500 };

  if (submitted) {
    return <span style={{ ...base, color: "#22c55e" }}>Submitted</span>;
  }
  if (dirty) {
    return <span style={{ ...base, color: "#f59e0b" }}>Unsaved changes...</span>;
  }
  if (lastSavedAt) {
    return (
      <span style={{ ...base, color: "#9ca3af" }}>
        Draft saved at{" "}
        {lastSavedAt.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })}
      </span>
    );
  }
  return <span style={{ ...base, color: "#9ca3af" }}>No changes yet</span>;
};

export default DraftStatus;
